export default [
    {
        name: 'Translate',
        icon: 'fad fa-arrows-alt',
        description: 'Click and drag or use the arrow keys to move a geo record. Press enter to save.',
    },
    {
        name: 'Rotate',
        icon: 'fas fa-sync-alt',
        description: 'Click and rotate the geo record.',
    },
    {
        name: 'Edit Geometry',
        icon: 'fas fa-draw-polygon',
        description:
            'Click and drag any point of the highlighted geo record to update the geo record geometry shape.',
    },
    {
        name: 'Edit Dimension',
        icon: 'far fa-rectangle-wide',
        description: '',
    },
];
